import { render, staticRenderFns } from "./FeedContentFollowUpPosition.vue?vue&type=template&id=15208f7e"
import script from "./FeedContentFollowUpPosition.vue?vue&type=script&lang=js"
export * from "./FeedContentFollowUpPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports